import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useSidePanel } from '~/contexts/SidePanelContext';

export const IssueUrlTracker = React.memo(
  function IssueUrlTracker() {
    const { dispatch, issueId: contextIssueId } = useSidePanel();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const issueId = searchParams.get('issueId') || '';

    // update context on url issueId change
    useEffect(() => {
      if (issueId && issueId !== contextIssueId) {
        dispatch('display-issue', { issueId });
      }
    }, [contextIssueId, dispatch, issueId]);

    // removes param from querystring after loading issue in context
    useEffect(() => {
      if (issueId && issueId === contextIssueId) {
        // ingest query params, and remove it from url
        setSearchParams((prev) => {
          return {
            ...Object.fromEntries(prev),
            issueId: [],
          }
        }, { replace: true, state: location.state });
      }
    }, [contextIssueId, issueId, location.state, setSearchParams]);

    return null;
  }
);
